import type { PanelComponentSpec } from '@src/types/LayoutConfig';
import { PANEL_COMPONENT_GROUPS } from '../Trading/groups';
import { AggregatedMetricPanel } from './AggregatedMetric/AggregatedMetricPanel';
import { AssetLeaderboardPanel } from './AssetLeaderboard/AssetLeaderboardPanel';
import { ComparisonPanel } from './Comparison/ComparisonPanel';
import { FundingRateBlotterPanel } from './FundingRateBlotter/FundingRateBlotterPanel';
import { HistoricalFundingRatePanel } from './HistoricalFundingRate/HistoricalFundingRatePanel';
import { SingleAssetMetricPanel } from './SingleAssetMetricPanel';

export const SIGNALS_PANEL_COMPONENTS: PanelComponentSpec[] = [
  {
    group: PANEL_COMPONENT_GROUPS['signals'],
    section: 'intel',
    type: 'marketCapEstimated',
    label: 'Single Asset Metric',
    icon: undefined,
    canBeAdded: true,
    renderer: SingleAssetMetricPanel,
  },
  {
    group: PANEL_COMPONENT_GROUPS['signals'],
    section: 'intel',
    type: 'aggregatedAssetMetric',
    label: 'Aggregated Asset Metric',
    icon: undefined,
    canBeAdded: true,
    renderer: AggregatedMetricPanel,
  },
  {
    group: PANEL_COMPONENT_GROUPS['signals'],
    section: 'intel',
    type: 'relativePerformance',
    label: 'Relative Performance',
    icon: undefined,
    canBeAdded: true,
    renderer: ComparisonPanel,
  },
  {
    group: PANEL_COMPONENT_GROUPS['signals'],
    section: 'intel',
    type: 'historicalFundingRate',
    label: 'Funding Rate History (USD Aggregated)',
    icon: undefined,
    canBeAdded: true,
    renderer: HistoricalFundingRatePanel,
  },
  {
    group: PANEL_COMPONENT_GROUPS['signals'],
    section: 'intel',
    type: 'fundingRateBlotter',
    label: 'Funding Rate Blotter (USD Aggregated)',
    icon: undefined,
    canBeAdded: true,
    renderer: FundingRateBlotterPanel,
  },
  {
    group: PANEL_COMPONENT_GROUPS['signals'],
    section: 'intel',
    type: 'assetLeaderboard',
    label: 'Asset Leaderboard',
    icon: undefined,
    canBeAdded: true,
    renderer: AssetLeaderboardPanel,
  },
];
